import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { useJsonApi } from "@/modules/api/hooks/useJsonApi";
import { queryKeys } from "@/modules/api/queryKeys";
import { apiErrorValidate } from "@/modules/api/utils/apiErrorValidate";
import { getCompaniesQuery } from "@/modules/auth/api/queries/getCompanies/getCompaniesQuery";

const translationNamespace = "apiMessages/useGetCompaniesQuery";

export function useGetCompaniesQuery(
  params: { userId: string } | { enabled: false }
) {
  const { t } = useTranslation(translationNamespace);
  const jsonApi = useJsonApi();

  return useQuery(
    "enabled" in params
      ? params
      : {
          queryKey: [queryKeys.companies.getCompaniesList, params.userId],
          queryFn: () => getCompaniesQuery(jsonApi, params.userId),
          retry: false,
          refetchOnWindowFocus: false,
          staleTime: Infinity,
          onError: (error) => {
            apiErrorValidate(error, {
              401: {
                UNAUTHORIZED: t(
                  "You are not allowed to view the company. Please sign in again"
                ),
              },
              403: {
                ACCESS_FORBIDDEN: t(
                  "You don't have an access to view the company"
                ),
              },
              404: {
                NOT_FOUND: t("User cannot be found"),
              },
            });
          },
        }
  );
}
